import React from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const SMPTconfiguration = () => {
  return (
    <div>
      <div className="main-content">
        <div>
          <h3>Add Reminder</h3>
        </div>
        <div className="boX">
          <div className="container mt-3">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <h6>Host</h6>
                <TextField
                  id=""
                  label="smtp.gmail.com"
                  variant="outlined"
                  sx={{ height: "48px", width: "100%" }}
                />{" "}
              </div>
              <div className="col-md-2">
                {/* <h6>Maintenance End Date</h6>
            <TextField
              className="mt-1"
              id=""
              label="Choose end Date"
              variant="outlined"
              sx={{ height: "48px", width: "100%" }}
            />{" "} */}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8 mt-3">
                <h6>SMTPAuth</h6>

                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Ture</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="select Traccar Device ID"
                      sx={{ height: "48px", width: "100%" }}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <h6>Username</h6>
                <TextField
                  id=""
                  label="mysmtp2020@gmail.com"
                  variant="outlined"
                  sx={{ height: "48px", width: "100%" }}
                />{" "}
              </div>
              <div className="col-md-2">
                {/* <h6>Maintenance End Date</h6>
            <TextField
              className="mt-1"
              id=""
              label="Choose end Date"
              variant="outlined"
              sx={{ height: "48px", width: "100%" }}
            />{" "} */}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>Password</h6>
                  <TextField
                    id="outlined-textarea"
                    label="*****"
                    type="password"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8 mt-3">
                <h6>SMTPSecure</h6>

                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">TLS</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="select Traccar Device ID"
                      sx={{ height: "48px", width: "100%" }}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>Port</h6>
                  <TextField
                    id="outlined-textarea"
                    label="587*"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>EmailFrom</h6>
                  <TextField
                    id="outlined-textarea"
                    label="mysmtp2020@gmail.com*"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>ReplyTo</h6>
                  <TextField
                    id="outlined-textarea"
                    label="mysmtp2020@gmail.com"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="mt-4 adDD">
                  <button>Text Email</button>

                  <button>Save Confi</button>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMPTconfiguration;
